import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { badgeStyles } from 'modules/_shared/constants/badgeStyles';

import './ColorPicker.scss';

type ColorPickerProps = {
  value: string;
  onChange: (style: string) => void; // eslint-disable-line
};

const ColorPicker: FC<ColorPickerProps> = ({ value, onChange }) => {
  const { t } = useTranslate();

  return (
    <div className="color-picker">
      <label className="form-label">{t('Color')}</label>
      <div className="color-picker__options">
        {badgeStyles.map((style) => (
          <button
            key={style}
            type="button"
            className={`color-picker__dot bg-${style} ${
              value === style ? 'color-picker__dot--selected' : ''
            }`}
            onClick={() => onChange(style)}
            title={style}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;
